module.exports = (__webpack_require__(9))(556);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/antd/es/tabs/index.js from dll-reference antd_library
// module id = 926
// module chunks = 42